import React, {useState} from "react";
import {connect} from "react-redux";
import {Button, Switch, Typography, withStyles} from "@material-ui/core";
import AuthenticatorModal from "./AuthenticatorModal";
import * as actions from "../store/profileActions";
import OverrideOtpModal from "./OverrideOtpModal";

const styles = theme => ({
    title: {
        display: "flex",
        alignItems: "center",
    },
    titleDisabled: {
        display: "flex",
        alignItems: "center",
        color: "gray",
    },
    methodsDiv: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(2),
    },
    editButton: {
        marginLeft: "auto",
    },
    methodsTitle: {
        backgroundColor: "#f6f8fa",
        border: "1px solid #e1e4e8",
        borderTopLeftRadius: "6px",
        borderTopRightRadius: "6px",
        margin: "-1px -1px 0",
        padding: "16px",
    },
    methodsBox: {
        backgroundColor: "#fff",
        border: "1px solid #e1e4e8",
        borderRadius: "6px",
    }
});

const TwoFactorAuthentication = (props) => {
    const { classes, activeCustomerID, translations, authenticationEnabled, updateAuthentication, fetchGenerateOTPAuth, fetchVerifyOtp, userSettings, fetchUserSettings, setUserSettings, fetchCancelAuth } = props;

    const [enabled, setEnabled] = useState(authenticationEnabled);
    const [authenticatorModal, setAuthenticatorModal] = useState({open: false, qrCodeValue: ""});
    const [overrideOtpModal, setOverrideModal] = useState({open: false});

    const handleEnableChange = async () => {
        const result = await updateAuthentication({ActiveCustomerID: activeCustomerID});
        if (result) {
            setEnabled(prevState => !prevState);
        }
        setUserSettings(await fetchUserSettings({ ActiveCustomerID: activeCustomerID }));
    }

    const handleAuthenticatorModalOpen = async (Type) => {
        setOverrideModal({open: false});
        if (Type!=="email") {
            const qrCodeValue = await fetchGenerateOTPAuth({ActiveCustomerID: activeCustomerID, Type});
            if (qrCodeValue) {
                setAuthenticatorModal({open: true, qrCodeValue: qrCodeValue?.URL, Type});
            }
        } else {
            setAuthenticatorModal({open: true, Type});
        }
    }

    const handleAuthenticatorModalClose = async () => {
        setAuthenticatorModal({open: false});
        const userSettings = await fetchUserSettings({ ActiveCustomerID: activeCustomerID });
        setUserSettings(userSettings);
    }

    const handleOverrideOtpModalOpen = (Type) => {
        setOverrideModal({open: true, Type});
    }

    const verifyOtp = async (OTP) => {
        const result = await fetchVerifyOtp({ActiveCustomerID: activeCustomerID, OTP, Type: authenticatorModal.Type});
        if (result?.Valid) {
            setAuthenticatorModal({open: false, qrCodeValue: ""});
        }
        const userSettings = await fetchUserSettings({ ActiveCustomerID: activeCustomerID });
        setUserSettings(userSettings);
    }

    const buttonText = (Type) => {
        if (userSettings?.Authentications && userSettings.Authentications[Type]) {
            return translations["edit"] || "Edit";
        } else {
            return translations["add"] || "Add"
        }
    }

    const handleButtonClick = (Type) => {
        if (userSettings?.Authentications && userSettings.Authentications[Type]) {
            handleOverrideOtpModalOpen(Type)
        } else {
            handleAuthenticatorModalOpen(Type)
        }
    }

    return (
        <>
            <div className={enabled? classes.title : classes.titleDisabled}>
                <h3>{translations["two_factor_authentication"] || "Two factor authentication"}</h3>
                <Switch
                    checked={enabled}
                    onChange={handleEnableChange}
                    color="primary"
                    name="Enabled"
                />
            </div>

            {enabled && userSettings &&
            <div className={classes.methodsBox}>
                <div className={classes.methodsTitle}>
                    <Typography variant={"body1"}>{translations["two_factor_methods"] || "Two factor methods"}</Typography>
                </div>

                <div className={classes.methodsDiv}>
                    <Typography variant={"body2"}>{translations["authenticator_app"] || "Authenticator app"}</Typography>
                    <Button variant={"contained"} className={classes.editButton} onClick={()=>handleButtonClick("authenticator_app")}>
                        {buttonText("authenticator_app")}
                    </Button>
                </div>
                <div className={classes.methodsDiv}>
                    <Typography variant={"body2"}>{translations["email"] || "Email"}</Typography>
                    <Button variant={"contained"} className={classes.editButton} onClick={()=>handleButtonClick("email")}>
                        {buttonText("email")}
                    </Button>
                </div>
            </div>}

            <OverrideOtpModal modal={overrideOtpModal} setOverrideModal={setOverrideModal} translations={translations} handleAuthenticatorModalOpen={handleAuthenticatorModalOpen} />
            <AuthenticatorModal modal={authenticatorModal} setAuthenticatorModal={setAuthenticatorModal} handleClose={handleAuthenticatorModalClose} translations={translations} verifyOtp={verifyOtp} fetchCancelAuth={fetchCancelAuth} activeCustomerID={activeCustomerID} fetchGenerateOTPAuth={fetchGenerateOTPAuth} fromSettings={true} />
        </>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        authenticationEnabled: state?.core?.login?.user?.AuthenticationEnabled || false,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateAuthentication : params => dispatch(actions.fetchAuthenticationEnableDisable(params)),
        fetchGenerateOTPAuth : params => dispatch(actions.fetchGenerateOTPAuth(params)),
        fetchVerifyOtp : params => dispatch(actions.fetchVerifyOtp(params)),
        fetchCancelAuth : params => dispatch(actions.fetchCancelAuth(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TwoFactorAuthentication));